import React, { useEffect, useState } from 'react';
import { Box, Tab, Tabs, Typography } from '@mui/material';
import CompanyManager from './CompanyManager';
import DepartmentsSettings from './DepartmentsSettings';
import PromptsSettings from './PromptsSettings';
import RobotSettings from './RobotSettings';
import SyncSettings from './SyncSettings';
import UnusedBrandsRobot from './UnusedBrandsRobot';
import BackupSettings from './BackupSettings';
import { Company } from '../types';
import { companiesApi } from '../services/api';

interface SettingsPageProps {
  initialTab?: string;
}

const TAB_KEYS = ['company', 'departments', 'prompts', 'robot', 'sync', 'unused-brands', 'backup'] as const;

const SettingsPage: React.FC<SettingsPageProps> = ({ initialTab }) => {
  const [activeCompany, setActiveCompany] = useState<Company | null>(null);
  const initial = TAB_KEYS.includes((initialTab || '') as typeof TAB_KEYS[number]) ? initialTab! : 'company';
  const [tab, setTab] = useState(initial);

  useEffect(() => {
    companiesApi.getActive().then(setActiveCompany).catch(() => setActiveCompany(null));
  }, []);

  const robotScopes = (() => {
    const mode = activeCompany?.assortment_mode || 'both';
    const scopes: Array<'brands' | 'categories' | 'tree'> = ['brands'];
    if (mode === 'categories' || mode === 'both') scopes.push('categories');
    if (mode === 'branches' || mode === 'both') scopes.push('tree');
    return scopes;
  })();

  return (
    <Box>
      <Typography variant="h5" fontWeight={700} gutterBottom>
        Настройки
      </Typography>
      {activeCompany && (
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Организация: {activeCompany.name}
        </Typography>
      )}
      <Tabs
        value={tab}
        onChange={(_, v) => setTab(v)}
        variant="scrollable"
        scrollButtons="auto"
        sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}
      >
        <Tab value="company" label="Компания" />
        <Tab value="departments" label="Департаменты" />
        <Tab value="prompts" label="Промпты" />
        <Tab value="robot" label="Робот" />
        <Tab value="sync" label="Синхронизация" />
        <Tab value="unused-brands" label="Неисп. бренды" />
        <Tab value="backup" label="Бэкапы" />
      </Tabs>
      {tab === 'company' && <CompanyManager onActiveChange={setActiveCompany} />}
      {tab === 'departments' && <DepartmentsSettings activeCompanyId={activeCompany?.id} />}
      {tab === 'prompts' && <PromptsSettings />}
      {tab === 'robot' && <RobotSettings scopes={robotScopes} activeCompanyId={activeCompany?.id} />}
      {tab === 'sync' && <SyncSettings />}
      {tab === 'unused-brands' && <UnusedBrandsRobot />}
      {tab === 'backup' && <BackupSettings />}
    </Box>
  );
};

export default SettingsPage;
